import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SelectMainNavigation } from "../../../redux/actions/adminActions";

// Opening a warranty screen from a bookmark or the search box should show the Warranty menu.
// Only for someone who may use the Warranty menu, and only on arrival: a later click on another main menu icon is the person's choice.
export const useWarrantyNav = (enabled) => {
  const dispatch = useDispatch();
  const { MainNavUrl } = useSelector((state) => state.adminReducers);
  const arrivedWith = useRef(MainNavUrl);
  useEffect(() => {
    if (enabled && arrivedWith.current !== "Warranty") {
      dispatch(SelectMainNavigation("Warranty"));
    }
  }, [dispatch, enabled]);
};
